<template>
  <div class="container">
    <div class="flex_vertial">
      <div class="flex_vertial" style="margin-top: 2rem">
        <div class="head_title_left">请输入验证码</div>
        <div class="hint_layout">
          <div class="hint_txt">已经发送至 {{ sendFormatNum }}</div>
          <div style="flex: 1;"></div>
          <div class="resendcode" v-if="senderTime">{{ senderTime }}s后可重试</div>
          <div class="resendcode" v-if="showRetry" @click="requestVerifyCode">重发验证码</div>
        </div>


        <div class="v-code">
          <input
            ref="vcode"
            id="vcode"
            type="tel"
            maxlength="6"
            v-model="code"
            @focus="focused = true"
            @blur="focused = false"
            :disabled="telDisabled">

          <label
            for="vcode"
            class="line"
            v-for="item,index in codeLength"
            :class="{'animated': focused && cursorIndex === index}"
            v-text="codeArr[index]"
          >
          </label>
        </div>
        <div style="flex: 1;"></div>
      </div>
      <div @click="sendVerifyCode" v-bind:class="{open_button_gray: !validNum, open_button: validNum}"
      >验证
      </div>
    </div>
    <AIPatternDialog v-if="showDialog" class="dialog-view"
                     :title="dialogTitle"
                     :desc="dialogDesc"
                     :cmd:="dialogCmd"
                     :op="dialogOp"
                     :cancel_op="dialogCancelOp"
                     :item="item"
                     :listeners="dialogListeners"/>
  </div>
</template>

<script>
import util from '@/utils/util'
import app from '@/AppData'
import lubanApi from '@/lubanApi'
import AIPatternDialog from '@/components/dialog/AIPatternDialog'
import {SERVICE_SWITCH} from '@/utils/const'
// const MAX_RETRY_TIMES = 1
const CUT_DOWN = 60

export default {
  name: 'bindPhone',
  components: {
    AIPatternDialog
  },
  data () {
    let that = this
    return {
      validNum: false,
      code: '',
      codeLength: 6,
      telDisabled: false,
      focused: false,
      sendFormatNum: null,
      senderTime: CUT_DOWN,
      verifySuccess: false,
      retryTimes: 0,
      showRetry: false,

      showDialog: false,
      dialogTitle: '验证码超时',
      dialogDesc: '是否重新获取验证码？',
      dialogOp: '重新获取',
      dialogCancelOp: '取消',
      item: {},
      dialogCmd: '',
      dialogListeners: {
        onClose () {
          console.log('onClose')
          that.showDialog = false
        },
        onClick () {
          console.log('onClick')
          that.showDialog = false
          that.code = ''
        },
      },
    }
  },
  mounted () {
    console.log(' tryToBindNum ' + app.getData().tryToBindNum)
    var num = app.getData().tryToBindNum
    // eslint-disable-next-line eqeqeq
    if (num !== null && num !== undefined && num.length === 11) {
      num = num.substring(0, 3) + '****' + num.substr(8)
    }
    this.sendFormatNum = num
    this.setTimeWatcher()
    console.log('mounted end')
  },

  computed: {
    codeArr () {
      return this.code.split('')
    },
    cursorIndex () {
      return this.code.length
    }
  },
  watch: {
    code (newVal) {
      this.code = newVal.replace(/[^\d]/g, '')
      if (this.code.length === 6) {
        this.$refs.vcode.blur()
        if (!this.validNum) {
          // 刚刚输入六位，帮用户主动验证
          this.sendVerifyCode(true)
        }
        this.validNum = true
      } else {
        this.validNum = false
      }
    }
  },
  methods: {
    setTimeWatcher () {
      // if (this.retryTimes >= MAX_RETRY_TIMES) {
      //   return
      // }

      let that = this
      that.senderTime = CUT_DOWN
      that.showRetry = false
      let timer = setInterval(function () {
        if (that.verifySuccess) {
          clearInterval(timer)
        } else {
          if (that.senderTime <= 0) {
            clearInterval(timer)
            that.handleTimeOut()
          } else {
            that.senderTime = that.senderTime - 1
          }
        }
        console.log('senderTime', that.senderTime, that.verifySuccess)
      }, 1000)
    },
    handleTimeOut () {
      console.log('handleTimeOut', 'retryTimes', this.retryTimes)
      // 显示重发
      this.showRetry = true
    },

    handleVerifyErr () {
      this.showDialog = true
      this.dialogTitle = '验证码错误'
      this.dialogOp = '重新输入'
      this.dialogDesc = '请输入正确的验证码'
    },

    requestVerifyCode () {
      // if(this.retryTimes >= MAX_RETRY_TIMES){
      //   console.log("requestVerifyCode exceed max times")
      //   this.showRetry = false
      //   return
      // }
      let num = app.getData().tryToBindNum
      lubanApi.sendPhoneCode(num).then(res => {
        console.log('requestVerifyCode success', res)
        if (res.data.code === 0 && res.data.data.resp.ret === 0) {
          console.log('requestVerifyCode success', res)

          this.retryTimes = this.retryTimes + 1
          this.setTimeWatcher()
        } else {
          console.error('requestVerifyCode failed1', res.data)
          util.Toast('发送验证码失败,请稍后重试')
        }
      }).catch(err => {
        util.Toast('发送验证码失败,请稍后重试')
      })
    },

    sendVerifyCode (auto = false) {
      console.log('sendVerifyCode', auto)
      if (this.code.length === 6) {
        var num = app.getData().tryToBindNum
        lubanApi.bindPhone(num, this.code).then(res => {
          this.verifySuccess = true
          if (util.isEmpty(app.getData().userSetting.phoneNum)) {
            app.putLocalStorage(SERVICE_SWITCH.NAME, SERVICE_SWITCH.STATE_NEED_SET_CALLFORWARD)//号码已经验证但是没有设置呼叫转移
          }
          this.$router.replace({
            path: '/bind_call_forward'
          })
          app.setNeedRefreshCalledList(true) // 首页需要重新加载列表
        }).catch(err => {
          console.log('verifyAndBind failed', err)
          if (auto !== true) {
            this.handleVerifyErr()
          }
        })
      }
    },

    validInput (event) {
      event.target.value = event.target.value.replace(/[^\d]/g, '')
      if (event.target.value.length == 6) {
        this.validNum = true
      } else {
        this.validNum = false
      }
    }
  }
}
</script>

<style scoped lang="less" src="@/styles/common.less"/>
<style scoped>
.container {
  width: 100%;
  height: 100%;
}

.v-code {
  margin-top: 0.5rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  width: calc(100% - 4rem);
  height: 3.4rem;
  margin-left: auto;
  margin-right: auto;
}

.v-code input {
  position: absolute;
  top: -100%;
  left: -666666px;
  opacity: 0;
}

.v-code .line {
  position: relative;
  text-align: center;
  line-height: 3.4rem;
  font-size: 2.78rem;
  width: 2.78rem;
  height: 3.4rem;
  border: 1px solid #DDDDDD;
  border-radius: 4px;
  margin-left: 0.3125rem;
  margin-right: 0.3125rem;
  top: 20%;
}

.v-code .line.animated::before {
  display: block;
  position: absolute;
  left: 50%;
  top: 20%;
  width: 1px;
  height: 60%;
  content: '';
  background-color: #333333;
  animation-name: coruscate;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
}

.hint_layout {
  width: calc(100% - 4rem);
  height: 2rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.hint_txt {
  font-family: PingFangSC-Regular;
  font-size: 1rem;
  color: #999999;
}


.resendcode {
  height: 1.6rem;
  border: 1px solid #999999;
  border-radius: 1.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  line-height: 1.6rem;
  font-family: PingFangSC-Regular;
  font-size: 0.75rem;
  color: #999999;
}

@keyframes coruscate {
  0% {
    opacity: 0
  }
  25% {
    opacity: 0
  }
  50% {
    opacity: 1
  }
  75% {
    opacity: 1
  }
  to {
    opacity: 0
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bind/BindPhoneVerify.vue